import { DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY } from '@/pages/dashboard/_config/constant';
import { fetchTopicWithTop, getFilterSettingListByGame, getStatsDate, getTopicStatsTimeline } from '@/pages/intelligence/services/opinion';
import { storage } from '@/utils/utils';
import { usePrevious } from 'ahooks';
import _ from 'lodash-es';
import moment from 'moment';
import React, { useState, useEffect, useMemo } from 'react';

export default (props: any) => {
  const { entityType, gameId, filterResult } = props

  // console.log("RPOPS", props)

  const onConfirm = (value: any) => {
    setParam({...param, ...value})
    setLoadingNew(true)
    // fetchData()
    getStatsDates({...param, ...value})
  }

  const [param, setParam] = useState({
    channel_comments: ["9999"],
    channel_news: ["9999"],
    channel_social: ["9999"],
    date_type: "daily",
    end_time: moment().format("YYYY-MM-DD 23:59:59"),
    has_account_history: undefined,
    has_keyword_history: undefined,
    is_valid: [],
    keyword: [],
    language: [],
    logic: "and",
    monitor_scource: [],
    platform: [],
    purpose: [],
    region: [],
    region_type: "region",
    reviews_rating: [],
    sentiment: [],
    social_media_by_account: [],
    social_media_by_keyword: [],
    start_time:  moment().format("YYYY-MM-DD 00:00:00"),
    topic: [],
    version: [],
    version_time: "1"
  })

  const PCTopicList = [
    'Character', 'Performance', 
    'Gameplay Experiences', 'Balancing', 
    'Monetization', "Beginner's Guide", 
    'Account', 'Social'
  ];

  const [loadingNew, setLoadingNew] = useState(true)
  // My Filter筛选器配置下拉选项
  const { userId } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};

  // Strengths & Weaknesses 数据
  const [radarItemArr, setRadarItemArr] = useState([]);
  const [radarLabelArr, setRadarLabelArr] = useState([]);
  const [topictabList, setTopictabList] = useState({});

  // topicMentions数据
  const [topicMentions, setTopicMentions] = useState([])

  // sentimentStacked数据
  const [sentimentStacked, setSentimentStacked] = useState([])

  // 获取stats数据
  let paramsobj =useMemo(()=>( {
    edition_unified_id: gameId,
    id_type: 'unified_id',
    user_id: userId,
    entity_type: entityType,
    statistics_field: 'overview',
    topic: PCTopicList
  }),[gameId,userId,entityType,PCTopicList])

  const getStatsDates = async (param) => {
    // 入参
    const tmp = { ...param, ...paramsobj }
    let result: any = await fetchTopicWithTop(tmp)

    setTopictabList({...param, ...paramsobj, topic: result||["1234"]})
    getRadarData(param, {...paramsobj, topic: result||["1256"]})
  }


  // 获得radar的数据
  const getRadarData = async (param, paramsobj) => {
    paramsobj.statistics_field = 'topic';
    
    let actChildren: any = []; // 官号
    if (filterResult?.monitor_by_account) {
      for (let v of Object.values(filterResult?.monitor_by_account?.monitory)) {
        actChildren = [...actChildren, ...v?.map((i: { account: any; }) => i?.account)];
      };
    }

    let addParams = {
      include_unlabeled_reviews: false,
      source: ['steam', 'opencritic', 'metacritic'],
      social_media_by_keyword: filterResult?.monitor_by_keyword?.monitoring || [],
      social_media_by_account: actChildren,
      top_n: 7,
      topic: []
    }

    // console.log("addParam", addParams)

    let result: any = await getTopicStatsTimeline({ ...param, ...paramsobj, ...addParams })
    let mentions = result?.mentions || []
    let itemArr = mentions?.map((item: any) => item.avg_sentiment.toFixed(2)) || [];
    let labelArr = mentions?.map((item: any) => item.name) || [];
    let mentionArr = mentions?.map((item: any) => {return {name: item.name, count: item.count}}) || [];

    let sentimentStacked = mentions?.map((item: any) => {
      const sum = item.negative_mentions + item.neutral_mentions + item.positive_mentions;
      return {
        time: item.name,
        sentiment_avg: item.avg_sentiment.toFixed(2),
        negative_mention: item.negative_mentions,
        neutral_mention: item.neutral_mentions,
        positive_mention: item.positive_mentions,
        negative_mention_rate: item.negative_mentions / sum,
        neutral_mention_rate: item.neutral_mentions / sum,
        positive_mention_rate: item.positive_mentions / sum,
      }
    }) || [];


    setRadarItemArr(itemArr);
    setRadarLabelArr(labelArr);
    setTopicMentions(mentionArr);
    setSentimentStacked(sentimentStacked)

    setLoadingNew(false)
  }

  // console.log({...topictabList, topic: radarLabelArr})
  // console.log("1", {...topictabList}, topictabList)


  
  
  return {
    onConfirm,
    param,
    radarItemArr,
    radarLabelArr,
    topictabList,
    filterResult,
    loadingNew,
    topicMentions,
    sentimentStacked,
    entityType,
    userId,
    gameId
  }
}